import { LinkRegular } from "@fluentui/react-icons";
import { GridColDef } from "@mui/x-data-grid";
import React from "react";
import { formatDate } from "../../helper/DateFormat";
import { ICustomerCommunityDetailsTableProps } from "../../interfaces/customer-community-details.interface";
import { CustomDataGrid } from "../../SharedComponents/CustomDataGrid/CustomDataGrid";

const CommunityTable = (props: ICustomerCommunityDetailsTableProps) => {
  React.useEffect(() => {
    setTimeout(() => {
      const elements = document.getElementsByClassName("MuiDataGrid-virtualScroller");
      Array.from(elements).forEach(function (element) {
        element.setAttribute("tabIndex", "0");
      });
      const rowgrpElements = document.querySelectorAll("[role=\"grid\"]");
      rowgrpElements.forEach(function (element) {
        element.setAttribute("aria-busy", "true");
      });
    }, 1000);
  }, []);
  const showNoData = () => {
    const rootStyle = {
      alignItems: "center",
      display: "flex",
      fontSize: 18,
      fontWeight: 600,
      justifyContent: "center",
      padding: 200
    };
    return <div style={rootStyle}>{`Community details are not available for ${props.tenantName} .`} </div>;
  };

  const columns: GridColDef[] = [
    {
      headerName: "ADO Link",
      field: "engagementIDADOLink",
      width: 130,
      sortable: true,
      renderCell: (params) => (
        <a
          style={{
            color: "rgb(0, 120, 212)",
            textDecoration: "none",
            fontSize: 26,
            cursor: "pointer"
          }}
          href={params.row.engagementIDADOLink}
          target="_blank"
          rel="noopener noreferrer"
          title={params.row.engagementIDADOLink}
          tabIndex={params.row.tabIndex}
        >
          <LinkRegular />
        </a>
      )
    },
    {
      headerName: "Engagement ID",
      field: "engagementID",
      width: 150,
      sortable: true
    },
    {
      headerName: "Engagement Title",
      field: "engagementTitle",
      width: 400,
      sortable: true
    },
    {
      headerName: "Product Family",
      field: "productFamily",
      width: 150,
      sortable: true
    },
    {
      headerName: "Solution Area",
      field: "solutionArea",
      width: 350,
      sortable: true,
      align: "left",
      headerAlign: "left"
    },
    {
      headerName: "Type",
      field: "engagementType",
      width: 170,
      sortable: true
    },
    {
      headerName: "End Date",
      field: "actualEndDate",
      type: "date",
      width: 150,
      sortable: true,
      flex:1,
      valueGetter: (value, row) => new Date(row.actualEndDate),
      renderCell: (params) => formatDate(params.row.actualEndDate)
    }
  ];

  return props?.tableData && props?.tableData.length > 0 ? (
    <div style={{ height: 600 }}>
      <CustomDataGrid
        columns={columns}
        exportCsvButtonProps={{
          fileNamePrefix: "programs"
        }}
         getRowId={(row) => row.rowId}
        rows={{
          values:
            props.tableData?.map((row, index) => ({
              ...row,
              rowId: row.engagementID + "_" + (index + 1)
            })) ?? [],
          count: props.tableData?.length ?? 0
        }}
        kustoLink={props.communityDetailsTableKustoLink}
        TabName={`Customer View - Community Details Table for ${props.tenantName}`}
      />
    </div>
  ) : (
    showNoData()
  );
};

export default CommunityTable;
